/**
 * Color utility functions for OC components
 */

/**
 * Adds an alpha channel to a color string
 * Supports hex, rgb, and rgba color formats
 * 
 * @param color - The color string (hex, rgb, or rgba)
 * @param alpha - The alpha value (0-1)
 * @returns The color string with alpha channel applied
 * 
 * @example
 * withAlpha('#ff0000', 0.5) // 'rgba(255, 0, 0, 0.5)'
 * withAlpha('rgb(255, 0, 0)', 0.5) // 'rgba(255, 0, 0, 0.5)'
 * withAlpha('rgba(255, 0, 0, 1)', 0.5) // 'rgba(255, 0, 0, 1)' (unchanged)
 */
export const withAlpha = (color: string, alpha: number): string => {
  // already rgba?
  if (color.startsWith("rgba")) return color;

  // rgb()
  if (color.startsWith("rgb")) {
    return color.replace("rgb(", "rgba(").replace(")", `, ${alpha})`);
  }

  // hex
  if (color.startsWith("#")) {
    let hex = color.replace("#", "");

    // expand shorthand
    if (hex.length === 3) {
      hex = hex.split("").map((c) => c + c).join("");
    }

    if (hex.length === 6) {
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }

  // fallback — let browser handle named colors
  return color;
};

